"use client"

import { LoggingProvider } from "@bullseye/components"
import { ErrorScreen } from "@bullseye/ui"

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

const GlobalError = ({ error, reset }: Props) => {
  return (
    <html lang="en">
      <body>
        <LoggingProvider>
          <ErrorScreen error={error} reset={reset} />
        </LoggingProvider>
      </body>
    </html>
  )
}

export default GlobalError
